import { render, staticRenderFns } from "./LightboxInternalLinkCard.vue?vue&type=template&id=50bd084e&scoped=true&"
import script from "./LightboxInternalLinkCard.vue?vue&type=script&lang=js&"
export * from "./LightboxInternalLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./LightboxInternalLinkCard.vue?vue&type=style&index=0&id=50bd084e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bd084e",
  null
  
)

export default component.exports